<app-table-form-container
	[loading]="loading()"
	modelName="Course"
	[showForm]="isFormShowing()"
	(onShowForm)="onShowForm()"
	(onHideForm)="onHideForm()"
>
	<ng-template #tableTemplate>
		<app-cms-table
			[tableKey]="'course-list'"
			[loading]="loading()"
			[rows]="courses()"
			[columns]="columns()"
			[selectedUuid]="editCourse()?.uuid"
			[uuidsInProgress]="uuidsInProgress()"
			(onSelect)="select($event)"
			(onCopy)="copy($event)"
			(onCopyBulk)="copyBulk($event)"
			(onEdit)="edit($event)"
			(onDelete)="delete$($event)"
			(onMoveUp)="moveUp$($event)"
			(onMoveDown)="moveDown$($event)"
		>
			<!-- Header templates (defines order/keys) -->
			<ng-template appHeaderColumn="courseName">Course</ng-template>

			<!-- Cell templates (matched by key; use {{ row.name }} etc.) -->
			<ng-template appRowColumn="courseName" let-row>
				<div class="name-column clickable">
					{{ row.active_text.name }}
				</div>
			</ng-template>
		</app-cms-table>
	</ng-template>

	<ng-template #formTemplate>
		<nz-card>
			@if (editCourse() && isStrideCourse()) {
				<app-rubric-content-levels-report [course]="editCourse()"></app-rubric-content-levels-report>
			}
			<app-language-selector (onChange)="onEditLanguageChange($event)"></app-language-selector>
			<app-course-form
				[course]="editCourse()"
				[editLanguage]="editLanguage()"
				(onSubmit)="onCourseFormSubmit$($event)"
			></app-course-form>
		</nz-card>
	</ng-template>
</app-table-form-container>
